"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */
const react_1 = require("@emotion/react");
const react_2 = require("react");
const CloseButton_1 = __importDefault(require("../../elements/CloseButton"));
const SaveButton_1 = __importDefault(require("../../elements/SaveButton"));
const styles = (0, react_1.css) `
  display: flex;
  flex-direction: row-reverse;
  border-bottom: 0.55px solid rgb(240 240 240);

  button {
    background-color: transparent;
    border: none;
    padding: 5px;
  }

  button:disabled {
    opacity: 0.6;
  }
`;
function PreferencesHeader({ onClose, onSave }) {
    return ((0, jsx_runtime_1.jsxs)("div", { css: styles, children: [(0, jsx_runtime_1.jsx)(CloseButton_1.default, { onClick: onClose, popupTitle: "Close preferences" }), (0, jsx_runtime_1.jsx)(SaveButton_1.default, { onClick: onSave, popupTitle: "Save preferences" })] }));
}
exports.default = (0, react_2.memo)(PreferencesHeader);
